function updateCartCounter(cart) {
    const counterEls = document.querySelectorAll('span.cart-counter');
    counterEls.forEach(el => {
      el.textContent = cart.item_count;
    });
  }

  function fetchAndUpdateCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => updateCartCounter(cart))
      .catch(error => console.error('Error fetching cart:', error));
  }

  // Listen for any known cart update events
  document.addEventListener('cart:updated', () => {
    fetchAndUpdateCart();
  });

  // Optionally listen for add-to-cart buttons
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', () => {
      setTimeout(fetchAndUpdateCart, 500); // wait for Shopify AJAX
    });
  });

  // Fallback polling every 30s instead of 1s
  setInterval(fetchAndUpdateCart, 10000); // Poll only as fallback